import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Renders about block with title and text.
 * @param {string} title
 * @param {string} classes
 * @param {node[]|string[]} items
 * @returns {ReactElement}
 */
export function AboutCalculator({ title, items, className = 'text-gray-darker' }) {
  const itemsLength = items.length - 1;
  return (
    <div className={className}>
      <h3 className="heading-5 mb-0">{title}</h3>
      {items.map((item, ind) => (
        // eslint-disable-next-line react/no-array-index-key
        <p className={classNames({ 'mb-0': ind === itemsLength })} key={ind}>
          {item}
        </p>
      ))}
    </div>
  );
}

AboutCalculator.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired,
};
